import React from 'react';
import history from 'app/routes/history';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import SchemaForm from 'app/components/general/SchemaForm';

const formSchema1 = {
  type: 'object',
  required: ['sendEmailNotification',
    'sendSMSNotification'],
  properties: {
    sendEmailNotification: {
      inputType: 'boolean',
      type: 'boolean',
      title: 'Send email notification (sent immediately upon confirmation)',
      default: true,
    },
    sendSMSNotification: {
      inputType: 'boolean',
      type: 'boolean',
      title: 'Send SMS notification (sent immediately upon confirmation)',
      default: true,
    },
  },
};

const uiSchema2 = {
  sendEmailNotification: { 'ui:field': 'boolean' },
  sendSMSNotification: { 'ui:field': 'boolean' },
};

const formSchema2 = {
  type: 'object',
  required: ['sendEmailReminders',
    'sendSMSReminders'],
  properties: {
    sendEmailReminders: {
      inputType: 'boolean',
      type: 'boolean',
      title: 'Send email reminders',
      default: true,
    },
    sendSMSReminders: {
      inputType: 'boolean',
      type: 'boolean',
      title: 'Send SMS reminders',
      default: true,
    },
  },
};

const uiSchema1 = {
  sendEmailNotification: { 'ui:field': 'boolean' },
  sendSMSNotification: { 'ui:field': 'boolean' },
};

interface IStep3SendNotificationsProps {
  isValid: Function;
  handleChange: Function;
  handleError: Function;
  formData: any;
  errors: any;
  changed: boolean;
  paymentRequests: any;
  originalFormData: any;
}

export default class Step3SendNotifications extends React.Component<IStep3SendNotificationsProps> {
  static defaultProps: IStep3SendNotificationsProps = {
    formData: undefined,
    changed: false,
    paymentRequests: undefined,
    originalFormData: undefined,
    isValid: undefined,
    handleChange: undefined,
    handleError: undefined,
    errors: undefined,
  };

  handleBack = () => {
    history.push('/payments/segments/requests/new/select');
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            {this.props.children}
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <SectionGroup title="Notifications">
              <div className="form-description">
                The selected payee/s can be notified and reminded to pay via email or SMS.
                Reminders are sent 7 days before the due date and on the due date.
              </div>
              <span className="form-section-title">Initial Payment Notification</span>
              <div className="form-section">
                <SchemaForm
                  uiSchema={uiSchema1}
                  schema={formSchema1}
                  handleChange={this.props.handleChange}
                  handleError={this.props.handleError}
                  renderButtons={false}
                  formData={this.props.formData}
                  errors={this.props.errors}
                  liveValidate={false}
                  isLoading={this.props.paymentRequests.isSaving}
                  hasSaved={this.props.paymentRequests.hasSaved}
                  hasFailed={this.props.paymentRequests.hasFailed}
                  originalFormData={this.props.originalFormData}
                />
              </div>
              <span className="form-section-title">Reminders</span>
              <div className="form-section">
                <SchemaForm
                  uiSchema={uiSchema2}
                  schema={formSchema2}
                  handleChange={this.props.handleChange}
                  handleError={this.props.handleError}
                  renderButtons={false}
                  formData={this.props.formData}
                  errors={this.props.errors}
                  liveValidate={false}
                  isLoading={this.props.paymentRequests.isSaving}
                  hasSaved={this.props.paymentRequests.hasSaved}
                  hasFailed={this.props.paymentRequests.hasFailed}
                  originalFormData={this.props.originalFormData}
                />
              </div>
            </SectionGroup>
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col btn-flex-group">
            <div className="btn-flex-container">
              <Button
                className="btn-standard btn-1"
                type="submit"
                onClick={() => {
                  history.push('/payments/segments/requests/new/confirm');
                }}
              >
                Next
              </Button>
              <Button onClick={this.handleBack} className="btn-standard btn-2">Back</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// import React from 'react';
// import PropTypes from 'prop-types';
// import { checkSetState } from '@teammo/teammo-general-utils';
// import { Label } from 'reactstrap';
// import Checkbox from 'app/components/general/Checkbox';
// import SectionGroup from 'app/components/general/SectionGroup';
// import FormDivider from 'app/components/general/FormDivider';
// import InputGroupBlock from 'app/components/general/InputGroupBlock';
// import Button from 'app/components/general/Button';

// export default class SendNotifications extends React.Component {
//   render(): React.ReactNode {
//     return (
//       <div>
//         <div className="row">
//           <div className="col">
//             <SectionGroup title="Send Notifications" className="">
//               <div className="form-description">
//                 The selected people can be notified and reminded to pay via
//                 email or SMS. Reminders are sent 7 days before the due date and
//                 on the due date.
//               </div>
//               <div className="row with-margin-top-10">
//                 <div className="col">
//                   <FormDivider title="Notifications">
//                     <div className="row">
//                       <div className="col">
//                         <Checkbox checked onClick={() => true} />
//                         <Label className="label-main">
//                           Send email notification (sent immediately)
//                         </Label>
//                       </div>
//                     </div>
//                     <div className="row with-margin-top-10">
//                       <div className="col">
//                         <Checkbox checked onClick={() => true} />
//                         <Label className="label-main">
//                           Send SMS notification (sent immediately)
//                         </Label>
//                       </div>
//                     </div>
//                   </FormDivider>
//                 </div>
//               </div>
//               <div className="row with-margin-top-10">
//                 <div className="col">
//                   <FormDivider title="Reminders">
//                     <div className="row">
//                       <div className="col">
//                         <Checkbox checked onClick={() => true} />
//                         <Label className="label-main">
//                           Send email reminders
//                         </Label>
//                       </div>
//                     </div>
//                     <div className="row with-margin-top-10">
//                       <div className="col">
//                         <Checkbox checked onClick={() => true} />
//                         <Label className="label-main">
//                           Send SMS reminders
//                         </Label>
//                       </div>
//                     </div>
//                   </FormDivider>
//                 </div>
//               </div>
//             </SectionGroup>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }
